import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
    <section id="container-footer">
      <a class="link-logo" href="https://www.egtec.com.br" target="_blank">
        <img
          src="../../../../assets/img/logos/logo-egtec-branco.png"
          id="logoEgtecRodape"
          alt="CONFEAR é um produto EGTEC"
          title="CONFEAR é um produto EGTEC" />
      </a>
    </section>
  `,
  imports: [CommonModule],
  standalone: true,
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {}
